import { Component, Inject, OnInit, inject } from '@angular/core';
import { USER_QUERIES, UserQueries } from '@/app/platform/platform-core/user/store/types';
import { PlatformModeService } from '@/app/platform/platform-core/platform-mode/platform-mode.service';

@Component({
    selector: 'app-dashboard-page',
    templateUrl: './dashboard-page.component.html',
    styleUrls: ['./dashboard-page.component.css'],
    standalone: false
})
export class DashboardPageComponent implements OnInit {
  constructor(
    @Inject(USER_QUERIES)
    readonly userQueries: UserQueries
  ) {}

  readonly platformMode = inject(PlatformModeService);

  ngOnInit(): void {}
}
